import { makeStyles, css } from '@conexasaude/hero'
import { keyframes } from '@emotion/react'
import { UseStylesProps } from './types'

const fadeIn = keyframes`
  from {
    opacity: 0;
    visibility: hidden;
  }
  to {
    opacity: 1;
    visibility: visible;
  }
`

const slideUp = keyframes`
  from {
    transform: translate3d(0, 100%, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
`

const show = keyframes`
  from {
    transform: scale(0.8);
  }
  to {
    transform: scale(1);
  }
`

const useStyles = makeStyles<UseStylesProps>({
  modalGeneral: () => {
    return css`
      position: fixed;
      top: 0;
      background-color: rgba(0, 0, 0, 0.8);
      width: 100vw;
      height: 100%;
      overflow-y: hidden;
      overflow-x: hidden;
      z-index: 50;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      animation: ${fadeIn} 0.1s forwards;

      @media (max-width: 639px) {
        justify-content: flex-end;
      }
    `
  },

  modalHeader: theme => {
    return css`
      display: flex;
      justify-content: flex-end;
      margin-bottom: 24px;

      @media (max-width: 639px) {
        margin-bottom: 0;
      }

      &.withTitle {
        justify-content: space-between;
        border-bottom: 1px solid ${theme.colors.extra.disabled_bg};
        padding-bottom: 24px;
      }

      h4 {
        color: ${theme.colors.neutral[900]};
      }

      button {
        background-color: unset;
        border: unset;
        position: relative;
        color: ${theme.colors.extra.gray_icon};
        padding: 0;
        font-size: 20px;
        cursor: pointer;
        width: 24px;
      }
    `
  },

  modalContent: (_, props) => {
    return css`
      position: relative;
      background-color: white;
      max-width: ${props?.settings?.width || '500px'};
      min-width: ${props?.settings?.width || '450px'};
      padding: 24px;
      border-radius: 16px;
      overflow: unset;
      box-sizing: border-box;
      animation: ${show} 0.2s forwards;

      @media (max-width: 639px) {
        box-sizing: border-box;
        width: 100%;
        border-radius: 16px 16px 0 0;
        min-width: unset;
        max-width: unset;
        max-height: 80vh;
        padding-right: 8px;
        animation: ${slideUp} 0.2s forwards;

        .modal-content {
          height: ${props.withoutHeader ? 'auto' : 'calc(100% - 51px)'};
          overflow-y: auto;
          padding-top: ${props.withoutHeader ? '0' : '24px'};
          padding-right: 16px;
        }
      }
    `
  },
})

export { useStyles }
